/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoverPhoto
 */
export interface CoverPhoto {
    /**
     * 
     * @type {string}
     * @memberof CoverPhoto
     */
    _640x?: string;
    /**
     * 
     * @type {string}
     * @memberof CoverPhoto
     */
    _2000x?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CoverPhoto
     */
    mirrors?: Array<string>;
}

/**
 * Check if a given object implements the CoverPhoto interface.
 */
export function instanceOfCoverPhoto(value: object): value is CoverPhoto {
    let isInstance = true;

    return isInstance;
}

export function CoverPhotoFromJSON(json: any): CoverPhoto {
    return CoverPhotoFromJSONTyped(json, false);
}

export function CoverPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverPhoto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '_640x': !exists(json, '640x') ? undefined : json['640x'],
        '_2000x': !exists(json, '2000x') ? undefined : json['2000x'],
        'mirrors': !exists(json, 'mirrors') ? undefined : json['mirrors'],
    };
}

export function CoverPhotoToJSON(value?: CoverPhoto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '640x': value._640x,
        '2000x': value._2000x,
        'mirrors': value.mirrors,
    };
}

